import { render, staticRenderFns } from "./FactureInterface.vue?vue&type=template&id=2dad03f3&scoped=true&"
import script from "./FactureInterface.vue?vue&type=script&lang=js&"
export * from "./FactureInterface.vue?vue&type=script&lang=js&"
import style0 from "./FactureInterface.vue?vue&type=style&index=0&id=2dad03f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dad03f3",
  null
  
)

export default component.exports